<template>
  <RecordViewWrapper>
    <sdPageHeader title="Entitas">
      <template #subTitle>
        <sdButton class="btn-add_new" size="default" type="primary">
          <router-link to="/masters/entitas-add"> <sdFeatherIcons type="plus" size="14" /> Tambah</router-link>
        </sdButton>
      </template>
      <template #buttons>
        <div class="search-box">
          <span class="search-icon">
            <sdFeatherIcons type="search" size="14" />
          </span>
          <a-input
            @change="handleSearch"
            v-model:value.trim="formState.searchItem"
            type="text"
            name="recored-search"
            placeholder="Search Here"
          /></div
      ></template>
    </sdPageHeader>

    <Main>
      <a-row :gutter="15">
        <a-col class="w-100" :md="24">
          <sdCards headless>
            <div v-if="isLoading" class="spin">
              <a-spin />
            </div>

            <div v-else>
              <TableWrapper class="table-data-view table-responsive">
                <a-table
                  :pagination="{ pageSize: 10, showSizeChanger: true }"
                  :dataSource="dataSource"
                  :columns="columns"
                />
              </TableWrapper>
            </div>
          </sdCards>
        </a-col>
      </a-row>
    </Main>
  </RecordViewWrapper>
</template>

<script>
import { RecordViewWrapper } from '../../../components/crud/style';
import { computed, onMounted, reactive } from 'vue';
import { Main, TableWrapper } from '../../styled';
import { useStore } from 'vuex';
import { Modal } from 'ant-design-vue';

const columns = [
  {
    title: 'Nama Entitas',
    dataIndex: 'nama_entitas',
    key: 'nama_entitas',
  },
  {
    title: 'Actions',
    dataIndex: 'action',
    key: 'action',
    width: '90px',
  },
];

const ViewPage = {
  name: 'ViewPage',
  components: { RecordViewWrapper, Main, TableWrapper },
  setup() {
    const { state, dispatch } = useStore();
    const crud = computed(() => state.crud.data);
    const isLoading = computed(() => state.crud.loading);

    onMounted(() => {
      dispatch('axiosCrudGetData', 'entitas');
    });

    const handleDelete = (id, nama_entitas) => {
      Modal.confirm({
        title: 'Konfirmasi',
        content: `Apakah Anda yakin ingin menghapus ${nama_entitas}?`,
        okText: 'Hapus',
        cancelText: 'Batal',
        onOk: () => {
          dispatch('axiosDataDelete', {
            id,
            url: 'entitas',
            getData: () => {
              dispatch('axiosCrudGetData', 'entitas');
            },
          });
        },
      });
    };

    const formState = reactive({
      searchItem: '',
    });

    const dataSource = computed(() =>
      crud.value.length
        ? crud.value.map((data, key) => {
            const { id, nama_entitas } = data;

            return {
              key: key + 1,
              nama_entitas,
              action: (
                <div class="table-actions">
                  <router-link class="edit" to={`/masters/entitas-edit/${id}`}>
                    <sdFeatherIcons type="edit" size={14} title="Ubah" />
                  </router-link>
                  &nbsp;&nbsp;&nbsp;
                  <router-link class="delete" onClick={() => handleDelete(id, nama_entitas)} to="#">
                    <sdFeatherIcons type="trash-2" size={14} title="Hapus" />
                  </router-link>
                </div>
              ),
            };
          })
        : [],
    );

    const handleSearch = () => {
      dispatch('axiosDataSearch', { url: 'entitas', filter: formState.searchItem });
    };

    return {
      formState,
      columns,
      isLoading,
      crud,
      dataSource,
      handleDelete,
      handleSearch,
    };
  },
};

export default ViewPage;
</script>
